<style lang="less">
.addAddress {
  .van-picker__cancel,
  .van-picker__confirm {
    font-size: 0.32rem;
  }
}
</style>

<template>
  <div class='addAddress'>
    <!-- <van-nav-bar title="新增收货地址"
                 v-if='this.isUpdate==0'
                 left-arrow
                 @click-left="onClickLeft" />
    <van-nav-bar title="修改收货地址"
                 v-else
                 left-arrow
                 @click-left="onClickLeft" /> -->
    <van-address-edit show-delete='true'
                      :area-list="this.areaList"
                      :address-info='this.$store.state.targetAddress'
                      show-set-default
                      show-search-result
                      @save="onSave"
                      @delete="onDelete" />
  </div>
</template>

<script>
//修改地址，可以从我的进入地址模块，也可以从订单模块中进入该模块。isBuyCard == 1 订单模块进入
import AreaList from '../../assets/js/area'
import { Area } from 'vant'
import { AddressEdit } from 'vant';
import { Toast } from 'vant';
export default {
  components: { AreaList },//引入组件1
  name: 'addAddress',
  data () {
    return {
      isUpdate: '0',
      areaList: AreaList,//赋值初始值
      searchResult: []
    }
  },
  mounted () {
    console.log(this.areaList);
    //this.areaList = areaList.areaList;//初始化选择器数据
    this.isUpdate = this.$route.params.isUpdate;
    if (this.isUpdate == 0) {
      //清空修改的目标
      this.$store.state.targetAddress = {};
    }
    //  console.log(this.initAddress);

    //修改返回
    window['backToMyAddress'] = () => {
      this.onClickLeft();
    }
  },
  methods: {
    //保存一个地址对象
    onSave (content) {
      if (this.isUpdate == 0) {
        //新增
        //debugger
        console.log('新增地址')
        console.log(content);
        console.log(typeof content);
        content.id = content.area_code + Math.random();//随机id，区分
        content.address = content.province + content.city + content.county + content.address_detail;
        this.$store.commit('addAddressList', content);  //使用commit提交出问题
        Toast('添加成功');
        // this.$router.push('/addressList');
        console.log(this.$store.state.addressList);

        if (this.$route.params.isCardAdd == 1) {
          Toast('修改成功');
          this.$router.push({ name: '/pay', params: { list: this.$store.state.commonGood } })
        }

      } else {
        //修改
        //debugger
        this.$store.state.addressList = this.$store.state.addressList.filter(item => {
          return item.id != content.id;
        })
        content.address = content.province + content.city + content.county + content.address_detail;
        this.$store.state.addressList.push(content);

        if (content.isBuyCard == 1) {
          this.$router.push({ name: '/pay', params: { list: this.$store.state.commonGood } })
        }
      }
    },
    onDelete () {

      this.$store.state.addressList = this.$store.state.addressList.filter(item => {
        return item.id != this.$store.state.targetAddress.id;
      });
      Toast('删除成功');
      if (this.$store.state.targetAddress.isBuyCard == 1) {
        this.$router.push({ name: '/pay', params: { list: this.$store.state.commonGood } })
      } else {
        this.$router.push('/addressList');
      }

    },
    onClickLeft () {
      this.$router.push('/addressList');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/address/addAddress.vue